/**
 * /me — Personal portal. Reuses EmployeeDetail in self-mode so the same UI
 * works for HR-viewed staff and for the staff member themselves. The
 * backend resolves the uid from the JWT, so there's no way for /me to leak
 * another person's data even if the client is tampered with.
 */
import EmployeeDetail from "./EmployeeDetail";

export default function Me() {
  return <EmployeeDetail selfMode />;
}
